<div class="console-page estilos-inyectables-page">
  <div class="console-content injectable-chrome">
    <app-page-header
      title="Estilos inyectables"
      description="Configuración de la demo (host SDK, credenciales, botón externo y tipografía)."
    ></app-page-header>
  </div>

  <div class="injectable-chrome demo-config console-content" *ngIf="!result">
    <app-console-section title="Configuración SDK">
      <div class="console-form-grid">
        <div class="console-field">
          <label class="console-field__label" for="demo-sdk-host">SDK (pay.button)</label>
          <select id="demo-sdk-host" class="console-select" [(ngModel)]="sdkHost" (ngModelChange)="onSdkHostChange()">
            <option *ngFor="let h of sdkHosts" [value]="h.id">{{ h.label }}</option>
          </select>
          <span class="console-field__hint">{{ currentSdkHost.url }}</span>
        </div>
        <div class="console-field">
          <label class="console-field__label" for="demo-api-key">API key</label>
          <input
            id="demo-api-key"
            class="console-input"
            type="text"
            autocomplete="off"
            spellcheck="false"
            [(ngModel)]="apiKey"
            (ngModelChange)="onCredentialsInput()"
            (change)="onCredentialsChange()"
          />
        </div>
        <div class="console-field">
          <label class="console-field__label" for="demo-secret">Secret</label>
          <input
            id="demo-secret"
            class="console-input"
            type="text"
            autocomplete="off"
            spellcheck="false"
            [(ngModel)]="secret"
            (ngModelChange)="onCredentialsInput()"
            (change)="onCredentialsChange()"
          />
        </div>
        <div class="console-field">
          <label class="console-field__label" for="demo-btn-style">Estilo del botón Pagar (externo al SDK)</label>
          <select id="demo-btn-style" class="console-select" [(ngModel)]="buttonStyle">
            <option *ngFor="let s of buttonStyles" [value]="s.id">{{ s.label }}</option>
          </select>
        </div>
        <div class="console-field">
          <label class="console-field__label" for="demo-typography">Tipografía (config typography del SDK)</label>
          <select id="demo-typography" class="console-select" [(ngModel)]="typography" (ngModelChange)="onTypographyChange()">
            <option *ngFor="let o of typographyOptions" [value]="o.id">{{ o.label }}</option>
          </select>
        </div>
      </div>
    </app-console-section>
  </div>

  <div *ngIf="result === 'success'" class="injectable-chrome result-screen result-success">
    <div class="result-icon">✓</div>
    <h2>¡Pago exitoso!</h2>
    <p class="result-message" *ngIf="payResult?.message">{{ payResult?.message }}</p>
    <p class="result-processor-message" *ngIf="payResult?.processorMessage">{{ payResult?.processorMessage }}</p>
    <div class="result-details" *ngIf="payResult?.orderNumber || payResult?.referenceNumber">
      <p *ngIf="payResult?.orderNumber"><strong>Orden:</strong> {{ payResult?.orderNumber }}</p>
      <p *ngIf="payResult?.amountLabel"><strong>Monto:</strong> {{ payResult?.amountLabel }}</p>
      <p *ngIf="payResult?.referenceNumber"><strong>Referencia:</strong> {{ payResult?.referenceNumber }}</p>
    </div>
    <button class="btn-back" (click)="handleBackFromResult()">Nueva compra</button>
  </div>

  <div *ngIf="result === 'error'" class="injectable-chrome result-screen result-error">
    <div class="result-icon">✕</div>
    <h2>Error en el pago</h2>
    <p class="result-message">{{ payResult?.message || 'Ocurrió un error en el pago.' }}</p>
    <p class="result-processor-message" *ngIf="payResult?.processorMessage">{{ payResult?.processorMessage }}</p>
    <p class="result-order" *ngIf="payResult?.orderNumber">Orden: {{ payResult?.orderNumber }}</p>
    <button class="btn-back" (click)="handleBackFromResult()">Intentar de nuevo</button>
  </div>

  <div *ngIf="!result" class="injectable-demo-surface">
  <div class="card">
    <div class="amount">Total: {{ currency }} {{ amount }}</div>

    <div
      *ngFor="let m of paymentMethods"
      class="payment-option"
      [class.selected]="selected === m.id"
      (click)="selectMethod(m.id)"
    >
      <div class="radio"></div>
      <span class="label">{{ m.label }}</span>
      <div class="logo"></div>
    </div>

    <div class="sdk-container" *ngIf="selected === 'cards' || selected === 'agora'">
      <div id="epago-form-container" #epagoContainer class="epago-container"></div>
    </div>

    <div class="checkout-separator" aria-hidden="true" *ngIf="selected === 'cards' || selected === 'agora'"></div>

    <button
      *ngIf="selected === 'cards' || selected === 'agora'"
      type="button"
      class="btn-pagar"
      [class.btn-pagar--green]="buttonStyle === 'green'"
      [class.btn-pagar--blue]="buttonStyle === 'blue'"
      [class.btn-pagar--red]="buttonStyle === 'red'"
      [class.btn-pagar--outline]="buttonStyle === 'outline'"
      [class.btn-pagar--dark]="buttonStyle === 'dark'"
      (click)="handlePayClick()"
      [disabled]="!formReady"
    >
      {{ !formReady ? 'Cargando...' : 'Pagar ' + currency + ' ' + amount }}
    </button>
  </div>
  </div>

  <p class="injectable-chrome demo-hint" *ngIf="!result">
    Ejemplo de integración con <code>hidePayButton: true</code> y <code>form.submit()</code>.
    El botón "Pagar" es externo al SDK.
  </p>
</div>
